import React from 'react'
import { connect } from 'react-redux'
import { fetchCurrentUser } from '../../redux/actions/users'
import PropTypes from 'prop-types'

class UserLoadWrapper extends React.Component {
  componentDidMount () {
    this.props.getUsers()
  }

  render () {
    return <React.Fragment>{this.props.children}</React.Fragment>
  }
}

UserLoadWrapper.propTypes = {
  children: PropTypes.node,
  getUsers: PropTypes.func
}

const mapDispatchToProps = dispatch => {
  return {
    getUsers: () => {
      dispatch(fetchCurrentUser())
    }
  }
}

export default connect(null, mapDispatchToProps)(UserLoadWrapper)
